import React from 'react';
import { ComingSoon } from './components/ComingSoon';
export function App() {
  return <ComingSoon data-id="element-0" />;
}